
import {ImageViewerComponent} from './image-viewer.component';
import {NgModule} from '@angular/core';
import {SecureURLPipeModule} from '../util/secureURL.pipe.module';
import {CommonModule} from '@angular/common';


@NgModule({
    imports: [
        SecureURLPipeModule,
        CommonModule
    ],
  declarations: [ImageViewerComponent],
  providers: [],
  exports: [ImageViewerComponent]
})

export class ImageViewerModule {

}
